import { getBasicOffers, getVariantPageUrl, hasOfferChance } from "../../../common/js/helpers"
import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

// Due to reasons how product collects analytics, the exit intent functionality is done
// via the roundtrip to a separate "exit intent" page with its own url without UI,
// and then back to the actual page, where discount is applied.
export default ({ exitIntentPagePath, discountPagePath, disabled }) => ({
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.store = Alpine.store("data")

    // If the discountPagePath provided - this is the exit intent page itself
    // and the action should be applied. 
    if (discountPagePath) {
      this.redirectFromExitIntent()
      return
    }

    if (this.isExitIntentAvailable()) {
      this.listenMouseOutExitIntent()
    }
  },

  isExitIntentAvailable() {
    // Listeners may be disabled for certain pages
    // while other methods from this cmp are still needed
    if (disabled) return false

    // Exit intent is already applied
    if (this.store.values.exitIntent) return false

    // Avoid page reload when closing exit intent popup
    if (this.store.values.isExitIntentPopupShown) return false

    // Disable exit intent mechanism for multi-month pipes if offers not configured
    const basicOffers = getBasicOffers(pipelineConfig.offers)
    const isMultiMonth = basicOffers.length > 1

    if (isMultiMonth) {
      const isDiscountConfigured = basicOffers.some(hasOfferChance)

      if (!isDiscountConfigured) {
        return false
      }
    }

    return true
  },

  // Init "mouseout" event listener
  listenMouseOutExitIntent() {
    window.addEventListener("mouseout", async (e) => {
      if (e.clientY < 0 && !this.store.values.isPaymentLoading) {
        window.location = getVariantPageUrl({ pagePath: exitIntentPagePath, pipelineConfig })
      }
    })
  },

  // Manually trigger exit intent - needed for touchscreens where we can't track "mouseout".
  // Accepts the callback to call if exit intent has been already applied to not prevent
  // the original flow
  handleBackButtonExitIntent(originalFn) {
    this.internalTracker.setEventToSessionStorage({ clickName: "Back Clicked" })
    if (this.isExitIntentAvailable() && !this.store.values.isPaymentLoading) {
      window.location = getVariantPageUrl({ pagePath: exitIntentPagePath, pipelineConfig })
    } else {
      originalFn ? originalFn() : history.back()
    }
  },

  // Triggered on separate "exit intent" page with its own url without UI
  redirectFromExitIntent() {
    // Set flag to show discount UI on the page we redirect to
    this.store.values.isExitIntentPopupShown = true

    // The `exitIntent` name kept for historical reasons
    // and it marks that discount is applied.
    // Set it right now, to let the new price be determined properly
    // during discount page init, which recreates checkout session
    this.store.values.exitIntent = true

    // Redirect to the page, where discount UI is shown

    window.location = getVariantPageUrl({ pagePath: discountPagePath, pipelineConfig })
  },

  applyExitIntentDiscount() {
    this.internalTracker.trackClick({ clickName: "Get Discount Selected" })
    this.store.values.isExitIntentPopupShown = false
  },

  isExitIntentPopupShown() {
    return this.store.values.isExitIntentPopupShown
  },

  isExitIntentApplied() {
    return this.store.values.exitIntent
  },

  // Not show discount UI before popup is closed
  isExitIntentUiApplied() {
    return this.isExitIntentApplied() && !this.isExitIntentPopupShown()
  },

  getExitIntentDiscount() {
    return this.store.pricing.getPriceDiscount({
      offer: this.store.values.activeOffer,
      isChance: this.store.values.exitIntent,
    })
  },
})